import { render, staticRenderFns } from "./chateau-cos-labory.vue?vue&type=template&id=6385bf78&scoped=true"
import script from "./chateau-cos-labory.vue?vue&type=script&lang=js"
export * from "./chateau-cos-labory.vue?vue&type=script&lang=js"
import style0 from "./chateau-cos-labory.vue?vue&type=style&index=0&id=6385bf78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385bf78",
  null
  
)

export default component.exports